// On-Track Technologies — the FRONTEND face of the client config seam. The '@client/config'
// vite alias resolves here in this fork (web/vite.config.js repoint — the
// fork's one sanctioned edit outside client-custom/).
//
// ONE SOURCE OF TRUTH: these values mirror ../config/client.config.js (the
// server face). The config suite asserts the two never drift — edit BOTH
// or the runner goes RED.

export const BRAND_NAME = 'On-Track Technologies';
export const BRAND_TAGLINE = 'World Class Manufacturing and Engineering Systems';
export const BRAND_SUBTITLE = '';
export const APP_TITLE = 'On-Track Technologies — Zebra Stride';
export const CUSTOMER_LABEL = 'Customer';

export const ADMIN_GROUP = 'site-admins';

// The site-switchers group — membership reveals the site switcher (see the
// server-side config). Mirrors client.config.js; the config suite checks.
export const SITE_SWITCH_GROUP = 'site-switchers';

// Workspaces — mirrors the server seam's workspacesEnabled (ON for this client).
export const WORKSPACES_ENABLED = true;
export const STORAGE_PREFIX = 'on-track-technologies';

export const PROJECT_ISSUE_TYPE = 'Project';
export const MODULE_ISSUE_TYPE = 'Module';
export const LINK_TYPE_NAME = 'Hierarchy';

export const WPO_FIELD = 'customfield_10001';

export const ACCENT_RGB = { r: 245, g: 163, b: 0 };

export const CUSTOMS_ALLOWED_HOSTS = [];

// This fork's own views of fields on the work item screen (the product's
// FIELD_VIEWS seam — modules/database/work-items/frontend/components/FieldView).
// "Log Review Time" on a Draughting Sub-task: whom the review time logs to
// (the Assigned Resource option matching the Requested Approver), the hours,
// and "Log Time" — a REVIEW TIME LOG sub-task created and moved to Done.
// Loaded through the '@client/customs' alias, never a relative path (Vite
// bundles this file).
export const FIELD_VIEWS = [
  { field: 'Log Review Time', load: () => import('@client/customs/log-review-time/LogReviewTime.jsx') },
  // OTT Assets (project OTTA, 2026-10-27 — client-custom/customs/ott-assets/DESIGN.md): the Asset's
  // card (its inspections, log, pictures and details folded away in it); the Inspection's checklist
  // and sign-off; the Data tab's schedule, checklist plan and log as readable lists that fit a small
  // screen. CNC (client-custom/customs/cnc/DESIGN.md): a CNC Part's machine stages and their steps in
  // one table (a machine stage's own, the same table), and its QIS — the inspection sheet, signed off
  // in place. Loaded through customs/ottFieldViews.js, never straight from here (it says why: the
  // app's startup bundle).
  ...['Asset Card', 'Inspection Checklist', 'Asset Log', 'Inspection Plan', 'Inspection Schedule', 'CNC Process', 'CNC Stage', 'QIS']
    .map((field) => ({ field, load: () => import('@client/customs/ottFieldViews.js').then((m) => m.OTT_FIELD_VIEWS[field]()) })),
];
